import React from 'react';
import LongText from '../../Elements/LongText';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import JsxHelper from '../../Helpers/JsxHelper';
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import GroupMemberAdmin from '../../Contents/Administration/UserGroups/GroupMemberAdmin';
import GroupChildrenAdmin from '../../Contents/Administration/UserGroups/GroupChildrenAdmin';
// import GroupAdmin from '../../Contents/Administration/UserGroups/GroupAdmin';

export default class GroupItem {
  constructor(item) {
    if (item === undefined) {
      this.GroupId = '';
      this.Name = '';
      this.Description = '';
      this.IsActive = false;
      return;
    }

    this.GroupId = item.groupId;
    this.Name = item.name;
    this.Description = item.description;
    this.IsActive = item.isActive;
  }

  static displayedInList = 'Name';

  static NameOfTheIdField() {
    return 'GroupId';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateOnlyFields = [];

  static DateFields = [];

  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    if (item)
      return (
        <span>
          Group Details -{' '}
          <LongText
            text={`${item.Name} (${item.GroupId})`}
            maxLength={40}
          />
        </span>
      );
    return 'Group Details';
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => GroupItem.editFunction(item.GroupId, item),
            roleKey: 'user_group_edit',
          },
        ]}
      />
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Group ID',
        orderById: 'GroupId',
        data: 'GroupId',
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      { label: 'Name', orderById: 'Name', data: 'Name' },
      { label: 'Description', orderById: 'Description', data: 'Description' },
      {
        label: 'Active',
        orderById: 'IsActive',
        data: (item) => JsxHelper.YesNo(item.IsActive),
        type: FieldTypesEnum.Bool,
      },
      {
        label: ' ',
        orderById: 'GroupId',
        data: GroupItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'GroupId', label: 'Group ID' },
        { name: 'Name', label: 'Name' },
        { name: 'Description', label: 'Description' },
      ],
    },
    {
      tabName: 'Group Members',
      tabLabel: 'Group Members',
      icon: 'fa-brands fa-grav fa',
      data: [
        {
          name: GroupItem.getGroupMembersContent,
          label: 'Group Members',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Child Groups',
      tabLabel: 'Child Groups',
      icon: 'fa-solid fa-sitemap',
      data: [
        {
          name: GroupItem.getChildGroupsContent,
          label: 'Child Groups',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static getGroupMembersContent(item) {
    return <GroupMemberAdmin groupId={item.GroupId} />;
  }

  static getChildGroupsContent(item) {
    return <GroupChildrenAdmin parentGroupId={item.GroupId} />;
  }
}
